const ind = state => state.navCount;
const tyleInd = state => state.tyleCount;
const comboInd = state => state.comboCount;
export{
	ind,
	tyleInd,
	comboInd
}


// WEBPACK FOOTER //
// ./src/vuex/getters.js